import { Component, DoCheck, HostBinding, OnDestroy, OnInit } from '@angular/core';
import {
  pageAnimatedContent, pageAnimatedHeader,
  navAnimatedMenu, navAnimatedHeader,
  sideAnimatedPanel, sideAnimatedContent,
  fullscreenAnimatedContent, fullscreenAnimatedHeader
} from '../animations';
import { NavService } from '../../services/nav-service';
import { IframeEmbedService } from '../../services/iframe-embed.service';
import { SidePanelService } from '../../services/side-panel-service';
import { IdleListenerService } from '../../services/idle-listener-service';
import { ScreenFullService } from '../../services/screenfull-service';
import { filterAnimatedContent, filterAnimatedPanel } from '../animations/animations.filterContainer';

@Component({
  templateUrl: 'master.html',
  styleUrls: ['./master.scss'],
  selector: 'app-master',
  animations: [
    filterAnimatedPanel, filterAnimatedContent,
    pageAnimatedContent, pageAnimatedHeader,
    navAnimatedMenu, navAnimatedHeader,
    sideAnimatedPanel, sideAnimatedContent,
    fullscreenAnimatedContent, fullscreenAnimatedHeader
  ]
})
export class MasterComponent implements DoCheck, OnInit, OnDestroy {
  sideAnimationStateTemp: string;
  filterContainerVisible = false;

  /** When true, shell chrome matches Upshop iframe embed (scoped global styles + side panel surface). */
  @HostBinding('class.cc-iframe-embed') get ccIframeEmbedHostClass(): boolean {
    return this.iframeEmbed.isIframeEmbed;
  }

  /**
   * Angular 7 has no per-trigger `.disabled` on `@fullscreenAnimatedContent`; iframe embed must not
   * run the legacy fullscreen content animation (inline `right` fights `sideAnimatedContent`).
   */
  get fullscreenContentAnimationState(): string {
    return this.iframeEmbed.isIframeEmbed ? 'noop' : this.screenFullService.screenfullAnimationState;
  }

  constructor(
    public nav: NavService,
    public iframeEmbed: IframeEmbedService,
    public sidePanel: SidePanelService,
    public idleListener: IdleListenerService,
    public screenFullService: ScreenFullService
  ) {}

  ngOnInit() {
    window.addEventListener('resize', this.resizeEvent, false);
    window.addEventListener('orientationchange', this.orientationchangeEvent, false);
  }

  resizeEvent = (event: any) => {
    this.sidePanel.updateViewComponents();
  }

  orientationchangeEvent = (event: any) => {
    this.sidePanel.updateViewComponents();
  }

  ngOnDestroy(): void {
    window.removeEventListener('resize', this.resizeEvent, false);
    window.removeEventListener('orientationchange', this.orientationchangeEvent, false);
  }

  // this solves the issue with value changed after checked (this was a persistent one)
  ngDoCheck() {
    // console.log('checking', this.sidePanel.sideAnimationState1);
    if (this.sidePanel.sideAnimationState !== this.sideAnimationStateTemp) {
      this.sideAnimationStateTemp = this.sidePanel.sideAnimationState;
    }
    this.filterContainerVisible = this.nav.showFilterContainer;
  }

}
